<div>
  <h2>Using Tala Pettige</h2>
  <ul>
    <li>Set the desired Tala, Jati, Nadai, Pitch using the dropdowns.</li>
    <li>Set the desired BPM using the +/- 5 and */ 2 buttons.</li>
    <li>Press Play to start the tala pettige</li>
    <li>
      You can change the Nadai, Pitch, and BPM while the pettige is running. For
      Tala and Jati changes, please stop and play.
    </li>
    <li>
      Stop/Play incase the lights go out of sync after making changes while the
      pettige was running.
    </li>
    <li>You can press on the squares to mute the akshara</li>
    <li>You can change the note for Up/Down beats in the settings menu</li>
  </ul>
  <hr />
  <h2>Support</h2>
  <p>
    Reach out to me on <a href="https://twitter.com/ibakasura" target="_blank"
      >Twitter</a
    >
    for any issues you have with the tala pettige.
  </p>
  <p>
    You can also
    <a href="https://buymeacoffee.com/tejovanthn" target="_blank"
      >buy me a coffee</a
    > if you like :)
  </p>
  <hr />
</div>

<style>
  li,
  p {
    font-size: 1rem;
  }
</style>
